import {FilterItemTyped} from "@kta20-ui-base/comps/models/filter-item";

export enum CustomFilterSelectionType {
    SINGLE_CHOISE = 'radio',
    MULTIPLE_CHOICE = 'checkbox'
}

export abstract class IUiSearchFilterComponent {
    static APPLY_FILTER_COMMAND = `kta20ApplyFilterCommand`;

    abstract searchFilterPlaceholder: string;
    abstract customFilterTitle: string;
    //customFilterSelectionType: CustomFilterSelectionType; // only single choice
    abstract customFilterSelectedValues: any[];
    abstract customFilterItems: Array<FilterItemTyped>;
    abstract customFilterConfirmLabel: string;
    abstract customFilterCancelLabel: string;
}

